import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: [],
  total_list: 0,
  isUploading: false,
  pagination: { num_page: 0, num_items: -1 },
  current_filters: {}
};

// getters
const getters = {
  getList: (state, getters, rootState, rootGetters) => id => {
    var categories = rootGetters["events/getCategoriesEventSelected"]();
    if (typeof id !== "undefined") return state.list[id];

    var data = [];
    for (var c in categories) {
      var category = categories[c];
      category.type = "category";
      data.push(category);
      for (var k in state.list) {
        var team = state.list[k];
        if (team.category_id == category.id) {
          data.push(team);
        }
      }
    }
    return data;
  },

  getListNoFiltered: (state, getters, rootState) => type => {
    var aClubs = [];
    for (var i in state.list) {
      if (state.list[i].visible) aClubs.push(state.list[i]);
    }
    return aClubs;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  }
};

// actions
const actions = {
  loadList({ commit, dispatch, getters, rootState, state }, params) {
    return api
      .get("competition/stats/teams/goals/event/" + params.event)
      .then(function(response) {
        if (response.status) {
          var data = response.data.data;
          for (var i in data) {
            data[i].visible = true;
            data[i].shield = data[i].team.shield;
            data[i].name = data[i].team.name;
          }

          commit("setList", { data: data, total: response.data.total });
          //   return commit("setPagination", page_options);

          //   return commit("setPagination", page_options);
        }
      });
  },

  load_by_id({ commit, dispatch, getters, rootState }, params) {
    return dispatch("competition/loadPhases", params, { root: true }).then(
      function(response) {
        return dispatch(
          "teams/loadList",
          {
            event: rootState.events.current_event.id,
            page_options: { num_page: -1, num_items: -1 },
            filters: { status: "6" }
          },
          { root: true }
        ).then(function() {
          return dispatch("competition/loadTemplTeams", params, {
            root: true
          }).then(function() {
            return dispatch("competition/loadRounds", params, {
              root: true
            }).then(function() {
              return dispatch("facilitys/loadList", params, {
                root: true
              }).then(function() {
                return dispatch("competition/groups/loadList", params, {
                  root: true
                }).then(function() {
                  var path = "competition/match/" + params.id;
                  return api.get(path).then(function(response) {
                    if (response.status) {
                      var data = response.data;

                      return commit("addMatch", data);
                    }
                  });
                });
              });
            });
          });
        });
      }
    );
  },

  editMatch({ commit, dispatch, getters, rootState }, params) {
    return api
      .post("competition/match/" + params.id + "/update", params.data)
      .then(function(response) {
        if (response.status) {
          var data = response.data;

          return commit("addMatch", data);
        }
      });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addMatch(state, match) {
    var list = { ...state.list };
    list[match.id] = match;

    state.list = list;
  },

  applyFilters(state, filters) {
    // console.log( "--- CLUBS APPLY FILTERS ---", filters )
    // var list = { ...state.list };
    // if (!filters) {
    //   for (var i in list) {
    //     list[i].visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     // console.log( " ---- ITEM " + item.name + " --- " );
    //     var bFound = true;
    //     for (var k in filters) {
    //       // console.log( "--- KEY: " + k + " ---" )
    //       if (filters[k] != -1) {
    //         var item_value =
    //           item[k] != null && typeof item[k] == "object"
    //             ? item[k].id
    //             : item[k];
    //         if (
    //           item.hasOwnProperty(k) &&
    //           filters[k] == null &&
    //           item_value == null
    //         ) {
    //         } else {
    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() )

    //           if (filters[k] != null && typeof filters[k] === "boolean")
    //             filters[k] = filters[k] ? 1 : 0;
    //           else if (filters[k] != null && typeof filters[k] === "string")
    //             filters[k] = filters[k].trim();

    //           // console.log( "KEY SEARCH: " + k + " ITEM: " + item_value + " - FILTER: " + filters[k] + " " + typeof filters[k] );
    //           var regexp = new RegExp(filters[k], "gi");

    //           if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] == "object" &&
    //             filters[k] != item_value
    //           ) {
    //             bFound = false;
    //           } else if (
    //             item.hasOwnProperty(k) &&
    //             typeof item[k] !== "object" &&
    //             !item_value.match(regexp)
    //           ) {
    //             bFound = false;
    //           }
    //         }
    //       }
    //     }

    //     list[i].visible = bFound;
    //   }
    // }

    // state.list = list;
    state.current_filters = filters;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setFirstTime(state, value) {
    state.bFirstTime = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
